<template>
  <div class="price-modal">
    <div class="price-table">
      <div class="price-table__header">
        <h4>ご利用料金</h4>
        <p class="text-muted">初期費用0円、時間単位でご利用いただけます</p>
      </div>
      
      <table class="price-table__content">
        <thead>
          <tr>
            <th>ご利用時間</th>
            <th>料金（税込）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1時間</td>
            <td class="price">¥1,440</td>
          </tr>
          <tr>
            <td>2時間</td>
            <td class="price">¥2,880</td>
          </tr>
          <tr>
            <td>3時間</td>
            <td class="price">¥4,320</td>
          </tr>
          <tr>
            <td>4時間</td>
            <td class="price">¥5,760</td>
          </tr>
        </tbody>
      </table>
      
      <div class="price-notes">
        <h5>ご利用にあたって</h5>
        <ul>
          <li>初回見学は無料です</li>
          <li>ご予約は2時間から承ります</li>
          <li>延長は15分単位で可能です<br />（※最低利用時間2時間から。15分¥360）</li>
          <li>キャンセル料金は7日前から発生します</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceModalContent'
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.price-modal {
  .price-table {
    &__header {
      text-align: center;
      margin-bottom: $spacing-xl;
      
      h4 {
        color: $primary-color;
        font-size: $font-size-2xl;
        margin-bottom: $spacing-sm;
      }
      
      p {
        margin: 0;
      }
    }
    
    &__content {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: $spacing-xl;
      
      th {
        background-color: $primary-color;
        color: $white;
        padding: $spacing-md;
        text-align: left;
        font-weight: 600;
      }
      
      td {
        padding: $spacing-md;
        border-bottom: 1px solid $gray-200;
        
        &.price {
          font-size: $font-size-lg;
          font-weight: 600;
          color: $primary-color;
          text-align: right;
        }
      }
      
      tr:last-child td {
        border-bottom: none;
      }
      
      tr:hover {
        background-color: $gray-100;
      }
    }
  }
  
  .price-notes {
    background-color: $gray-100;
    padding: $spacing-lg;
    border-radius: $radius-md;
    
    h5 {
      font-size: $font-size-lg;
      color: $primary-color;
      margin-bottom: $spacing-md;
    }
    
    ul {
      margin: 0;
      padding-left: $spacing-lg;
      
      li {
        margin-bottom: $spacing-sm;
        color: $gray-700;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}</style>